
import axios from '../config/axios';

export const url = '/api/contactochambatalksm1d9z'


export const createcontactochambatalksm1d9z = ({
  token,
	dnih5ov3i,
	nombretnyzf,
	correoi3fpm,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && dnih5ov3i && correoi3fpm ) {

    axios.post(`${url}//create/basic/6910e849e3072492500743ad`, {
		dnih5ov3i,
		nombretnyzf,
		correoi3fpm,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!dnih5ov3i) {
		reject({
			status: 'error',
			info: 'DNI no esta definido',
		});
	}  else if (!correoi3fpm) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

